import type { AppRedirect } from '#src/shared/routes';

// The impact page replaced the About page at `/about`; `/impact` stays as a permanent redirect
// so existing links and bookmarks land on the new route.
export const REDIRECTS: readonly AppRedirect[] = [
	{
		path: '/impact',
		buildUrl: ({ queryString }) => `/about${queryString}`,
		permanent: true,
	},
];
